import { render, staticRenderFns } from "./ReservationDetails.vue?vue&type=template&id=22f18fdb&scoped=true"
import script from "./ReservationDetails.vue?vue&type=script&lang=js"
export * from "./ReservationDetails.vue?vue&type=script&lang=js"
import style0 from "./ReservationDetails.vue?vue&type=style&index=0&id=22f18fdb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f18fdb",
  null
  
)

export default component.exports